<template>
    <div class="mx-auto px-4 py-4 sm:px-6 lg:px-6">
        <h3 class="text-lg leading-6 font-medium">
            Membership Report
        </h3>
        <div class="
          bg-white
          shadow
          overflow-hidden
          sm:rounded-lg
          shadow
          overflow-auto
          border-b border-gray-200
          sm:rounded-lg
        ">
            <form class="mt-5 sm:flex sm:items-center px-8">
                <div class="w-full sm:max-w-md mr-2">
                    <select class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus:border-blue-600
                        focus:outline-none
                    " aria-label="Month select example" v-model="search.status">
                        <option value="">All Statuses</option>
                        <option value="Active">Active Membership Report</option>
                        <option value="Inactive">Inactive Membership Report</option>
                        <option value="Terminated">Terminated Membership Report</option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <select class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus:border-blue-600
                        focus:outline-none
                    " aria-label="Month select example" v-model="search.company">
                    <option value="">Select Company</option>
                    <option :value="com.id" v-for="com in company_list"
            :key="com.id">
            {{ com.name }}, {{com.number}}
        </option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <select class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus:border-blue-600
                        focus:outline-none
                    " aria-label="Month select example" v-model="search.payment_type">
                    <option value="">All Payment Types</option>
                    <option value="I-Invoice">I-Invoice</option>
                    <option value="P-Payroll">P-Payroll</option>
                    <option value="V-Credit Card">V-Credit Card</option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <select class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus:border-blue-600
                        focus:outline-none
                    " aria-label="Month select example" v-model="search.last_pay_day">
                        <option value="">All Payments</option>
                        <option value="No Pmts">No Payments</option>
                        <option value="30">Payments Last 30 Days</option>
                        <option value="60">Payments Last 30-60 Days</option>
                        <option value="90">Payments Last 60 plus Days</option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <input 
                        type="text"
                        class="
                            h-10
                            form-input
                            appearance-none
                            block
                            w-full
                            px-3
                            py-1.5
                            text-base
                            font-normal
                            text-gray-700
                            bg-white bg-clip-padding bg-no-repeat
                            border border-solid border-gray-300
                            rounded
                            transition
                            ease-in-out
                            m-0
                            focus:text-gray-700
                            focus:bg-white
                            focus:border-blue-600
                            focus:outline-none
                        "
                        placeholder="Search by member name"
                        aria-label="Member name search"
                        v-model="search.member"
                    />
                </div>
                <div class="w-full sm:max-w-md mr-2 items-center justify-between">
                    <button class="
                  mt-1
                  mr-2
                  relative
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  shadow-sm
                  text-sm
                  font-medium
                  rounded-md
                  text-white
                  focus:outline-none focus:ring-2 focus:ring-offset-2
                  cobalt-button-color
                " type="button" @click="getReportData()">
                        Search
                    </button>
                    <button class="
                  mt-1
                  mr-2
                  relative
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  shadow-sm
                  text-sm
                  font-medium
                  rounded-md
                  text-white
                  focus:outline-none focus:ring-2 focus:ring-offset-2
                  cobalt-button-color
                " v-if="data?.length > 0" type="button" @click="exportCSV($event)">
                        Export
                    </button>
                    <button class="
                  mt-2
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  rounded-md
                  shadow-sm
                  text-sm
                  font-medium
                  text-white
                  bg-gray-400
                  hover:bg-gray-700
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-gray-500
                " type="button" @click="clearFilter()">
                        Clear
                    </button>
                </div>
            </form>
            <DataTable  id="membership_report" @page="onPageChange($event)"
            @sort="onSort($event)"
            filterDisplay="row"
            ref="dt"
            :totalRecords="totalRecords"
            :first="first"
            :lazy="lazyParams" :paginator="true"
            :resizableColumns="true" columnResizeMode="expand"
              class="mt-5 min-w-full divide-y divide-gray-200"
              :value="data"
              :alwaysShowPaginator="false"
              :rowsPerPageOptions=[5,10,20,50,70,100]
              :rows="10"
            >
              <template #empty>
                No Records Found
              </template>
              <ColumnGroup type="header">
                <row>
              <Column
              :style="{ 'width': '50px' }"
            v-for="column in columns"
            :key="column.title"
            :field="column.key"
            exportFilename="exportfilename"
            :header="column.title"
            :sortable="(column.key=='name' || column.key=='last_name' || column.key=='first_name') && totalRecords>0"
          >
          <template #body="slotProps" v-if="column.key == 'mem_num'">
            <span class="tooltip text-blue-400 cursor-pointer" @click="openMemberDetails(slotProps?.data,true)"><span class="tooltip-text">View Member details</span><i class="fa fa-user-circle-o" aria-hidden="true"></i> {{ slotProps?.data?.mem_num }}</span>
            </template>
          </Column>
          </row>
          </ColumnGroup>
            </DataTable>
        </div>
        <div id="practice_detail" class="hidden edit-profile">
      <div
        tabindex="0"
        class="z-40 left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-2/5 md:w-full">
          <div class="bg-white px-4 mt-2 pt-5 pb-4 sm:p-2 sm:pb-1 rounded-lg">
            <div
              class="flex flex-row justify-between p-1 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800 p-1"><i class="fa fa-user-circle-o" aria-hidden="true"></i> Member Information
               </p>
            </div>
            <div class="flex flex-col">
                <div class="grid grid-cols-2 gap-4">
                <div class="p-4 border">
                    <p class="font-bold">Member Name</p>
                    <p>{{member_details?.first_name}} {{member_details?.last_name}}</p>
                </div>
                <div class="p-4 border">
                    <p class="font-bold">Member Phone</p>
                    <p>{{member_details?.phone}}</p>
                </div>
                <div class="p-4 border">
                    <p class="font-bold">Member Email</p>
                    <p class="break-all">{{member_details?.email}}</p>
                </div>
                <div class="p-4 border">
                    <p class="font-bold">Member Address</p>
                    <p>{{member_details?.address1}}, {{member_details?.city}}, {{member_details?.state}} - {{member_details?.zip}}</p>
                </div>
                </div>
                <button
                type="button"
                @click="openMemberDetails(false)"
                class="self-end md:w-1/6 w-full mb-2 mr-5 mt-6 rounded-md group relative flex justify-center py-3 px-3 border border-transparent text-md font-medium text-white bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-50"
                aria-required="true"
              >
                <i
                  class="fa fa-circle-o-notch mr-1 mt-1"
                  aria-hidden="true"
                ></i>
                <span>Close</span>
              </button>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
    </div>
</template>
  
<script>
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery"; // To use jquery
import Constants from "../constants.ts";
// import axios from "axios";
import { ref } from 'vue';
export default {
    data() {
        return {
            member_details:{},
            focusedInput: null,
            API_BASE: Constants.API_BASE,
            columns: [
                {
                    title: "Company #",
                    key: "com_num",
                },
                {
                    title: "Company Name",
                    key: "name",
                },
                {
                    title: "Member ID#",
                    key: "mem_num",
                },
                {
                    title: "Last Name",
                    key: "last_name",
                },
                {
                    title: "First Name",
                    key: "first_name",
                },
                {
                    title: "Member Status",
                    key: "member_status",
                },
                {
                    title: "Plan(s)",
                    key: "planType",
                },
                {
                    title: "Payment Type",
                    key: "payment_method",
                },
                {
                    title: "Effective Date",
                    key: "effective_date",
                },
                {
                    title: "Last Payment Date",
                    key: "last_payment_date",
                },
                {
                    title: "Inactive Date",
                    key: "inactive_date",
                },
                {
                    title: "Termination Date",
                    key: "terminated_date",
                }
            ],
            search: {
                flt_str: ""
            },
            first : ref(0),
            totalRecords :ref(0),
            lazyParams : ref({}),
            company_list:[],
            data: ref(0),
            totalAmount: 0,
            totalComm: 0,
            config: {
                wrap: true,
                altFormat: "m-d-Y",
                altInput: true,
                dateFormat: "m-d-Y",
            },
        };
    },
    computed: mapState(["agent_user","token"]), // get central level variable from store
    mounted() {
        this.search.status = 'Active';
        this.search.company = '';
        this.search.payment_type = '';
        this.search.last_pay_day = '';
        this.search.member = '';
        this.getCompany();
        // this.getReportData();
        this.lazyParams.value = {
        first: 0,
        rows: 10,
    };
    },
    methods: {
        onSort(event){  
            console.log(event)
            this.lazyParams.value = event;
            this.getReportData(event);
        },
        onPageChange(event) {
        this.lazyParams.value = event;
        this.getReportData(event);
        $('html, body').animate({ scrollTop: 0 });
    },
        openMemberDetails(details='',flag){
            if (flag) {
                this.member_details=details;
                document.getElementById("practice_detail").classList.remove("hidden");
            } else {
                document.getElementById("practice_detail").classList.add("hidden");
                this.$store.dispatch("getAttProfileData");
            }
        },
        onFocus(refKey) {
            this.focusedInput = refKey;
        },
    getCompany(){
        this.$http
                .get(
                    `fetch_agent_company.php`,
                    {
                        headers: {
                            Authorization: this.token,
                            AgentSelected:this.agent_user.id
                        },
                    }
                )
                .then((response) => {
                    if (response?.data?.status == "unAuthorized") {
                                document.getElementById("loader").classList.add("hidden");
                                this.$toast.error(response.data.message);
                                this.$store.dispatch("logout");
                                this.$router.push("/login");
                            } else {
                        console.log(response);
                        this.company_list = response.data;
                    }
                })
                .catch((e) => {
                    this.$store.state.loader = false;
                    console.log("e", e);
                });
    },
        exportCSV() {
            // this.$refs.dt.exportCSV();
            let filter_str = "?";
            filter_str += "&last_pay_day=" + this.search.last_pay_day;
            filter_str += "&member=" + this.search.member;
            filter_str += "&status=" + this.search.status;
            filter_str += "&company=" + this.search.company;
            filter_str += "&payment_type=" + this.search.payment_type;
            filter_str += "&report_name=membership_report";
            filter_str += "&act=" + encodeURIComponent(this.token);
            filter_str+="&agents="+this.agent_user.id;
            console.log(filter_str)
            window.location.href = this.API_BASE + "export_to_csv.php" + filter_str;
        },
        clearFilter() {
            this.search.flt_str="";
            this.search.status = '';
            this.search.company = '';
            this.search.payment_type = '';
            this.search.last_pay_day = '';
            this.search.member = '';
            this.data=[];
            this.totalRecords=0
            // this.getReportData();
        },
        getReportData(event) {
            document.getElementById("loader").classList.remove("hidden");

            this.lazyParams.value = { ...this.lazyParams.value, first: event?.first || this.first };
                    let filter={'limit':10,'offset':0,'sortField':'name asc'};
                    if(event?.rows>0){
                        let order='asc';
                        if(event.sortOrder==-1){
                            order='desc';
                        }
                        if(event.sortField=='' || event.sortField==null){
                            event.sortField='name'; 
                        }
                        filter={'limit':event.rows,'offset':event.first,'sortField':event.sortField+' '+order};
                    }
                    
                    this.$http
                        .post(
                            `membership_report.php`,
                            {'search':this.search,"paginate":filter},
                            {
                                headers: {
                                    Authorization: this.token,
                                    AgentSelected:this.agent_user.id
                                },
                            }
                        )
                        .then((response) => {
                            document.getElementById("loader").classList.add("hidden");
                            this.$store.state.loader = false;
                            if (response?.data?.status == "unAuthorized") {
                                document.getElementById("loader").classList.add("hidden");
                                this.$toast.error(response.data.message);
                                this.$store.dispatch("logout");
                                this.$router.push("/login");
                            } else {
                                console.log(response);
                                this.data = response.data.data;
                                this.totalRecords = response.data.totalRecords;
                            }
                        })
                        .catch((e) => {
                            document.getElementById("loader").classList.add("hidden");
                            this.$store.state.loader = false;
                            console.log("e", e);
                        });
        },
    },
};
</script>
<!-- <style scoped>
table th, table td{
  white-space: normal !important;
  font-size: 14px !important;
}
</style> -->